import { render } from "./subscriptiontabset.vue?vue&type=template&id=d08798dc"
import script from "./subscriptiontabset.vue?vue&type=script&lang=js"
export * from "./subscriptiontabset.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__